import { TypePolicy } from "@apollo/client";

import { stateVar } from "../../hooks/useAppState";
import { lastView, sumProgress } from "../../util/cache";

export default {
  merge: true,
  fields: {
    progress: {
      read: (_, { readField }) => sumProgress("slides", readField),
    },
    lastView: {
      read: (_, { readField }) => lastView("slides", readField, stateVar().instanceId),
    },
  },
} as TypePolicy;
